// import config from '../config/config'
import axios from 'axios'
import config from '../config/config'
export default class API {
  constructor(route, imageFileds) {
    this.route = route
    this.imageFileds = imageFileds
    // this.url = config.serverUrl;
  }
  async GetAll(params) {
    //  console.log("api", params);
     console.log(this.route);
    try {

      const response = await axios.get(`/${this.route}`, { params })
      let { data } = response
      if (params) data = response.data.data
      if (this.imageFileds) this.addImagePath(data, this.imageFileds)
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async Show(id, params) {
    try {
      const response = await axios.get(`/${this.route}/${id}`, { params })
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async Insert(data, headers = {}) {
    try {
      const response = await axios.post(`/${this.route}`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async Updata(data, headers = {}) {
    let { id } = data
    if (!data.id) {
      id = data.get('id')
      data.append('_method', 'PUT')
    }
    try {
      const response = await axios.post(`/${this.route}/${id}`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async UpdataPut(data, headers = {}) {

    
    try {
       
      const response = await axios.put(`/${this.route}/${data.id}`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async Delete(id, recordIds = []) {
    try {
      const response = await axios.delete(`/${this.route}/${id}`, {
        data: { recordIds },
      })
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  addImagePath(obj, fileds = []) {
    obj.map(element => {
      fileds.forEach(filed => {
        element[filed] = config.serverUrl + element[filed]
      })
    })
  }
  error(error) {
    if (error.response) {
      // Request made and server responded
      return error.response.data;
    } else if (error.request) {
      // The request was made but no response was received
      return error.request;
    } else {
      // Something happened in setting up the request that triggered an Error
      return { 'Error': error.message };
    }
  }
  // async HasMany(model,id,Key) {/DELETE
  //     const res = await fetch(this.url + this.route)
  //     const { results } = await res.json();
  //     const modelRes = await fetch(this.url + model+"/"+)
  //     const { modelresults } = await modelRes.json();
  //     results.map(item => {
  //         item[model]=modelresults
  //     });
  //     return result;
  // }
}